var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadEvent),expression:"loadEvent"}],attrs:{"infinite-scroll-distance":_vm.distance,"infinite-scroll-disabled":"disabled","infinite-scroll-immediate-check":"immediateCheck"}},[_vm._t("load-up"),_vm._t("default"),_vm._t("load-down")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }